// extracted by mini-css-extract-plugin
export default {"patientCurrentTreatmentsContainer":"PatientCurrentTreatments_patientCurrentTreatmentsContainer__6Bf69"};